import React, { Children } from "react";
const SidePanel = (props) => {
  const classes =
    "sidePanel border-r border-gray-300 bg-blue-50 " + props.className;
  return <div className={classes}>{props.children}</div>;
};
export default SidePanel;
